// extracted by mini-css-extract-plugin
module.exports = {"section":"section__3z4Id","title":"title__2r13m","body":"body__VdQMV","withdrawal-label-wrapper":"withdrawal-label-wrapper__eNazN"};